<template>
  <div class="datepicker" :class="(query.range.start !== '' && query.range.start !== null) ? 'input--has--value' : ''">
    <v-date-picker
        v-model="query.range"
        mode="date"
        :masks="masks"
        :min-date='new Date()'
        :locale="this.current_locale"
        :select-attribute="attributes"
        :popover="{ visibility: 'click' }"
        :drag-attribute="attributes"
        :model-config="modelConfig"
        :is-range="true"
        :columns="$screens({ default: 1, md: 2 })"
        :is-expanded="$screens({ default: true, md: false })"
    >
      <template v-slot="{ inputValue, inputEvents, isDragging }">
        <div class="datepicker-wrap">
          <div class="datepicker-input-wrap">
            <input readonly="readonly" v-on="inputEvents.start" type="text" :placeholder="null" :value="query.range.start ? query.range.start + ' / ' + query.range.end : ''">
              <span class="input--arrow">
                <svg width="5" height="10" viewBox="0 0 5 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.191434 9.84396C-0.0475602 9.62106 -0.0651732 9.24159 0.152094 8.99639L3.69331 5L0.152095 1.00361C-0.0651731 0.758412 -0.0475601 0.378944 0.191434 0.15604C0.430429 -0.0668642 0.800303 -0.0487938 1.01757 0.196401L4.79721 4.46186C5.0676 4.767 5.0676 5.233 4.79721 5.53814L1.01757 9.8036C0.800303 10.0488 0.430429 10.0669 0.191434 9.84396Z" fill="#7A7A7A"/>
                </svg>
              </span>
            <input
                type="hidden"
                :value="inputValue.start"
                v-on="inputEvents.start"
            />
            <input
                type="hidden"
                :value="inputValue.end"
                v-on="inputEvents.end"
            />
          </div>
        </div>
      </template>
    </v-date-picker>
  </div>
</template>

<script>
export default {
  name: 'DatePicker',
  data: () => ({
    query: {
      range: {
        start: null,
        end: null
      }
    },
    masks: {
      input: 'DD MMMM',
      output: 'YYYY-MM-DD'
    },
    modelConfig: {
      type: 'string',
      mask: 'DD MMM YY' // Uses 'iso' if missing
    },
      current_locale: { id: 'en', firstDayOfWeek: 1, masks: {} },
      attributes: {
      highlight: {
        start: {
          style: {
            backgroundColor: '#000000' // black
          },
          contentStyle: {
            color: '#ffffff' // color of the text
          }
        },
        base: {
          style: {
            backgroundColor: '#F3F1F0' // light grey
          }
        },
        end: {
          style: {
            backgroundColor: '#000000' // black
          },
          contentStyle: {
            color: '#ffffff' // color of the text
          }
        }
      }
    }
  }),
  props: ['data', 'values'],
  watch: {
    query: {
      handler (value) {
        this.$store.commit('from_date', this.query.range.start)
        this.$store.commit('to_date', this.query.range.end)
        this.$emit('fromToDates', this.query.range)
      },
      deep: true,
      immediate: true
    },
    values: {
      handler (value) {
        this.query.range.start = this.values ? this.values.from : null
        this.query.range.end = this.values ? this.values.to : null
      },
      deep: true,
      immediate: true
    }
  },
  components: {
  },
  computed: {
  },
  mounted () {
      this.current_locale.id = current_locale
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../../scss/global/includes";

.datepicker {
  position: relative;
  &.input--has--value {
    .input--arrow svg path  {
      fill: $primary-grey;
    }
    input {
      color: $primary-grey;
      border: 1px solid $primary-grey;
      background: $blue-15-opacity;
    }
  }

}

.datepicker-input-wrap {
    width: 100%;
    max-width: 100%;
    display: block;
    position: relative;
    margin-bottom: 8px;
}

.datepicker-input-wrap label {
    color: $primary-grey;
    font-size: 14px;
    padding-bottom: 8px;
    display: block;
}

.datepicker-input-wrap input {
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    box-shadow: none !important;
    outline: none;
    font-size: 14px;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 1px solid $divider-dark;
    color: $primary-grey;
    border-radius: 4px;
    margin-bottom: 0px;
    padding: 16px 10px;
    display: block;
    width: 100%;
    outline: none;
    background: #FFFFFF;
    cursor: pointer;


    &:focus {
      // border: 1px solid $primary;
      // color: $primary;
    }

    @include placeholder {
      color: $primary-grey;
    }
}

.datepicker-input-wrap .input--arrow {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translate(0px, -50%);
}


.vc-popover-content-wrapper {
  position: fixed!important;
  top: 50%!important;
  left: 50%!important;
  @include transform(translate(-50%, -50%)!important);
  z-index: 1009!important;
  .vc-popover-content {
    box-shadow: rgba(0,0,0, 0.2) 0 6px 20px !important;
    border: 0;
  }
  .vc-weekday {
    color: $primary-grey !important;
    font-size: 12px !important;
  }
  .vc-day-content.is-disabled {
    color: $mid-light !important;
  }
  .vc-day {
    padding: 10px;
  }
  .vc-header {
    padding: 20px 18px;
  }
  .vc-arrows-container {
    padding: 20px 10px;
  }
  .vc-pane {
    padding: 20px;
    @include breakpoint(tablet) {
      padding: 0;
    }
  }
  .vc-popover-caret {
    display: none;
  }
}

@media only screen and (max-width: 1021px) {
  .vc-popover-content-wrapper {
    top: 0% !important;
  }
}
</style>
